import React, { Component, forwardRef } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Main from "../../../modules/pages/Main"
import Catalogs from "../../../modules/catalogs"
import Wizard from "../../../modules/wizard"
import Projection from "../../../modules/forecast"
import Scheduler from "../../../modules/scheduler"

const moduleRoutes = [
  {
    path: "/scheduler/:subpage?",
    component: Scheduler
  },
  {
    path: "/catalogs/:subpage?",
    component: Catalogs
  },
  {
    path: "/wizard/:subpage?",
    component: Wizard
  },
  {
    path: "/forecast/:subpage?",
    component: Projection
  },
  {
    path: "/asignaciones"
  },
  {
    path: "/scheduler"
  },
  {
    path: "/",
    component: Main
  }
]

class Shell extends Component<{}, {}> {
  render() {
    return (
      <>
        <Switch>
          {moduleRoutes.map(route => (
            <Route key={route.path} path={route.path} component={route.component} />
          ))}
        </Switch>
      </>
    )
  }
}

export default Shell
